<template>
<div class="container-fluid">
	<div class="row">
	    <div class="col-12">
			<h1 data-test="pageTitle">Smart Lists</h1>
			<div class="card">
				<div class="card-body">
					Smart lists are automatically automatically generated from Wildfire Labs data, your EMR system data, and other data sources to help with planning community education and outreach efforts.
				</div>
			</div>
			
			<div class="smartlists" :class="[config.layout, { 'card-deck' : config.layout == 'desktop'}]">
				<template v-for="smartlist in smartlists">
					<router-link :to="{ name: smartlist.route }" class="card d-flex" :class="{ 'flex-row w-100' : config.layout == 'mobile' }">
						<div class="smartlist-icon px-3 pt-3" :class="{ 'pb-3' : config.layout == 'mobile' }">
							<div class="rounded-circle avatar-lg text-4xl text-center text-white">
								<i class="fad" :class="smartlist.icon"></i>
							</div>
						</div>
						<div class="smartlist-info p-3" :class="{ 'my-auto' : config.layout == 'mobile' }">
							<div class="text-blue-700 text-lg font-weight-bold mb-1">{{ smartlist.name }}</div>
							<div class="text-sm text-gray-700">{{ smartlist.desc }}</div>
						</div>
					</router-link>
				</template>
			</div>
		</div>
	</div>
</div>
</template>

<script>
    import { mapState } from 'vuex'
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';
	
	export default {
		mixins: [BreadcrumbsManager],

		data() {
			return {
				smartlists: [
					{
						name: 'RADAR',
						route: 'smart_lists.radar',
						icon: 'fa-radar',
						desc: 'Local physicians identified by the Referrer Acquisition and Development Algorithm as most likely to refer patients',
					},
					{
						name: 'New Physicians',
						route: 'smart_lists.new',
						icon: 'fa-users-medical',
						desc: 'Physicians added within the last 30 days',
					},
					{
						name: 'Top Physicians',
						route: 'smart_lists.top',
						icon: 'fa-trophy-alt',
						desc: '25 highest-rated physicians by Referrer Score',
					},	
					{
						name: 'New Referrers',
						route: 'smart_lists.new_referrers',
						icon: 'fa-user-injured',
						desc: 'Physicians with a referral in the last 30 days',
					},	
					{
						name: 'Latent Referrers',
						route: 'smart_lists.latent',
						icon: 'fa-alarm-clock',
						desc: 'Highest-rated physicians without a checkin in more than 6 months',
					},																	
				]			
			};
		},

		created() {			
		},

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Providers', to: { name: 'physicians.list'} },
                { text: 'Smart Lists', to: { name: 'smart_lists.index'} },
            ]);   
        },

        computed: {
        	...mapState(['config'])
        }	
	}
</script>